<template>
  <!-- eslint-disable max-len -->
  <LayoutContent>
    <LayoutContent
      inner
      padding
    >
      <div class="box-info">
        <h3 class="title">Custom Payment Page Credit Card/Debit Card</h3>
        <p class="description">You can customize payment page for credit card. This preview will appear when your customer using Credit Card/Debit Card for their payment
          method.</p>
      </div>
    </LayoutContent>
    <LayoutContent
      style="margin-top: 20px"
      inner
      padding
    >
      <div
        class="box-info"
        style="display: flex"
      >
        <div style="flex: 1;">
          <h3 class="title">Setting</h3>
          <div>
            <div class="form-group">
              <h5 class="label">Business Name</h5>
              <div class="box-input">
                <Select
                  v-model="selectLanguage"
                  :options="language"
                  placeholder="Select Channel ID"
                  subtitle="Select all or some Channel ID"
                  emptyMessage="Enter Channel ID"
                  noResultMessage="Channel ID not found"
                />
              </div>
            </div>
            <div class="form-group">
              <h5 class="label">Merchant Logo</h5>
              <div class="box-input">
                <input
                  type="file"
                  accept="image/jpeg"
                  formenctype="multipart/form-data"
                  @change="uploadImage"
                >
                <span style="color: red; font-size: small">{{ messageImage }}</span>
              </div>
            </div>
            <div style="margin-top: 10px">
              <h5 class="label">Background Color</h5>
              <div class="box-input file">
                <input
                  v-model="backgroundColor"
                  type="color"
                  class="color"
                >
                <FormInput
                  v-model="backgroundColor"
                  placeholder="Background Color"
                  name="Transaction Number"
                  type="text"
                />

              </div>
            </div>
            <div style="margin-top: 10px">
              <h5 class="label">Panel Background Color</h5>
              <div class="box-input file">
                <input
                  v-model="panelBackgroundColor"
                  type="color"
                  class="color"
                >
                <FormInput
                  v-model="panelBackgroundColor"
                  placeholder="Panel Background Color"
                  type="text"
                />

              </div>
            </div>
            <div style="margin-top: 10px">
              <h5 class="label">Panel Text Color</h5>
              <div class="box-input file">
                <input
                  v-model="panelTextColor"
                  type="color"
                  class="color"
                >
                <FormInput
                  v-model="panelTextColor"
                  placeholder="Panel Text Color"
                  type="text"
                />

              </div>
            </div>
            <div style="margin-top: 10px">
              <h5 class="label">Button Submit Background Color</h5>
              <div class="box-input file">
                <input
                  v-model="btnSubmitBackgroundColor"
                  type="color"
                  class="color"
                >
                <FormInput
                  v-model="btnSubmitBackgroundColor"
                  placeholder="Button Submit Background Color"
                  type="text"
                />

              </div>
            </div>
            <div style="margin-top: 10px">
              <h5 class="label">Button Submit Text Color</h5>
              <div class="box-input file">
                <input
                  v-model="btnSubmitTextColor"
                  type="color"
                  class="color"
                >
                <FormInput
                  v-model="btnSubmitTextColor"
                  placeholder="Button Submit Text Color"
                  type="text"
                />
              </div>
              <input
                type="checkbox"
                v-model="toggleBilling"
                true-value="1"
                false-value="0"
                style="font-size: 8px"
              > Use Billing Info
            </div>
          </div>
        </div>
        <div
          style="flex: 2;padding-left: 10px;"
          class="box2"
        >
          <h3 class="title">Preview</h3>
          <div class="preview">
            <div
              class="panel"
              ref="preview"
              v-bind:style="'background:' + panelBackgroundColor + '; color:' + panelTextColor "
            >
              <h4 class="orderSummary">Your Order Summary</h4>
              <div class="form-group-panel">
                <label class="label">Merchant Name</label>
                <p class="divider">:</p>
                <p class="value">PT Sprint Asia Technology</p>
              </div>
              <div class="form-group-panel">
                <label class="label">Transaction No</label>
                <p class="divider">:</p>
                <p class="value">1234567</p>
              </div>
              <div class="form-group-panel">
                <label class="label">Description</label>
                <p class="divider">:</p>
                <p class="value">Merchant Sprint Transaction</p>
              </div>
              <div class="form-group-panel">
                <label class="label">Product</label>
              </div>
              <div class="form-group-panel item">
                <label class="label">1.Item Name</label>
                <p class="divider">: IDR</p>
                <p class="value">100.000</p>
              </div>
              <div class="form-group-panel item">
                <label class="label">2.Item Name</label>
                <p class="divider">: IDR</p>
                <p class="value">150.000</p>
              </div>
              <div class="form-group-panel item">
                <label class="label">Amount</label>
                <p class="divider">: IDR</p>
                <p
                  class="value"
                  style="font-size: small"
                >150.000</p>
              </div>
              <div class="form-group-panel">
                <label class="label">Customer Name</label>
                <p class="divider">:</p>
                <p class="value">Jhon Doe</p>
              </div>
              <div class="form-group-panel">
                <label class="label">Phone Number</label>
                <p class="divider">:</p>
                <p class="value">+62 823 2323 3233</p>
              </div>
              <div class="form-group-panel">
                <label class="label">Email</label>
                <!--                <p class="divider">:</p>-->
                <p
                  class="value"
                  style="width: 55%;text-align: left"
                >: ecm.support@sprintasia.net</p>
              </div>
              <div class="form-group-panel">
                <label class="label">Address</label>
                <p class="divider">:</p>
                <p class="value">JL. Fatmawati no 7</p>
              </div>
            </div>
            <div
              class="form-previw"
              v-bind:style="'background:' + backgroundColor +'; height:' + heightPreview +'px'"
            >
              <div style="padding: 10px;">
                <div style="text-align: right;"><img
                    class="logo"
                    src="https://bayarind.id//asset/img/logo-bayarind.png"
                  /></div>
                <div style="margin-top: 50px; width: 80%">
                  <input
                    class="preview-input"
                    type="text"
                    placeholder="Card Number"
                  />
                </div>
                <div style="margin-top: 15px; width: 90%; display: flex;">
                  <select
                    class="preview-input"
                    style="flex: 1;"
                  >
                    <option hidden>MM</option>
                    <option value="">01</option>
                    <option value="">02</option>
                    <option value="">03</option>
                    <option value="">04</option>
                    <option value="">05</option>
                    <option value="">06</option>
                    <option value="">07</option>
                    <option value="">08</option>
                    <option value="">09</option>
                    <option value="">10</option>
                    <option value="">11</option>
                    <option value="">12</option>
                  </select>
                  <select
                    class="preview-input"
                    style="flex: 1;margin-left: 5px;"
                  >
                    <option hidden>YY</option>
                    <option
                      v-for="(item,index) in listYear"
                      :key="index"
                    >{{item}}</option>
                  </select>
                </div>
                <div style="margin-top: 15px; width: 30%">
                  <input
                    class="preview-input"
                    type="text"
                    placeholder="CVC"
                  />
                </div>
                <div style="margin-top: 15px; width: 80%">
                  <input
                    class="preview-input"
                    type="text"
                    placeholder="Name On Card"
                  />
                </div>
                <button
                  class="btn-preview"
                  v-bind:style="'background: ' + btnSubmitBackgroundColor + ';color: ' + btnSubmitTextColor "
                >Paynow</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutContent>
    <div class="btn-container">
      <Button
        @click="onSetStep(5)"
        variant="button"
        size="mini"
      >Previous</Button>
      <Button
        @click="saveCc()"
        variant="button"
        size="mini"
        :disabled="validatedButton === true"
      >Save</Button>
    </div>
  </LayoutContent>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import FormInput from '@/components/FormInput.vue';
import Select from '@/components/Select.vue';
import api, { apiSandbox } from '@/libs/api';
import { mapState } from 'vuex';
import dayjs from 'dayjs';

@Component({
  components: {
    LayoutContent,
    Button,
    FormInput,
    Select,
  },
  computed: mapState(['user']),
})
export default class Step6 extends Vue {
  @Prop(Function) onSetStep;
  backgroundColor = '#ffffff';
  panelBackgroundColor = '#000000';
  panelTextColor = '#ffffff';
  btnSubmitBackgroundColor = '#000000';
  btnSubmitTextColor = '#ffffff';
  selectLanguage = 'English';
  heightPreview = 0;
  imageLogo = [];
  mcode = '';
  messageImage = '';
  toggleBilling = 0;
  validatedButton = true;
  language = [
    'English',
    'Indonesia',
  ];

  mounted() {
    this.heightPreview = this.$refs.preview.clientHeight;
  }

  uploadImage(e) {
    const file = e.target.files[0];
    this.imageLogo = file;
    this.messageImage = '';
    this.validatedButton = false;
    if (file.size >= 100000) {
      this.messageImage = 'Merchant logo size should be less than 100 KB!';
      this.validatedButton = true;
    }
  }

  async saveCc() {
    const formData = new FormData();
    formData.append('use_billing_info', this.toggleBilling === '' ? '0' : this.toggleBilling);
    formData.append('backgroundColor', this.backgroundColor);
    formData.append('btnSubmitBackgroundColor', this.btnSubmitBackgroundColor);
    formData.append('btnSubmitTextColor', this.btnSubmitTextColor);
    formData.append('lang', this.selectLanguage === 'English' ? 'EN' : 'IN');
    formData.append('panelTextColor', this.panelTextColor);
    formData.append('panelBackgroundColor', this.panelTextColor);
    formData.append('panelTextColor', this.panelTextColor);
    formData.append('merchantLogo', this.imageLogo);
    const { status } = await apiSandbox.post('/payment-page?', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    // eslint-disable-next-line no-useless-catch
    try {
      if (status === 200) {
        this.$router.push('dashboard');
      }
    } catch (e) {
      throw e;
    }
  }

  setSelectedTab(idx) {
    this.activeTab = idx;
  }

  // eslint-disable-next-line
  get listYear() {
    try {
      let dateCounter = dayjs();
      const dateEnd = dayjs().add(18, 'year');
      const result = [];

      while (dateEnd.diff(dateCounter, 'year') >= 0) {
        result.push(dateCounter.format('YY'));
        dateCounter = dateCounter.add(1, 'year');
      }
      return result;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  display: flex;
  /* align-items: end; */
  justify-content: flex-end;
  margin: 15px 15px;
}
.btn-preview {
  margin-top: 15px;
  border: none;
  padding: 7px 10px;
  font-size: small;
  border-radius: 2px;
}
.form-previw {
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
  //padding: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  flex: 1;
  .preview-input {
    border: 1px solid #003f7e;
    border-radius: 5px;
    padding: 6px 12px 6px 10px;
    outline: none;
    transition: 0.1s;
    width: 100%;
    box-sizing: border-box;
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    line-height: 19px;
  }
}
.preview {
  display: flex;
  padding: 15px;
  align-items: flex-start;
  align-content: flex-start;
  .logo {
    width: 40%;
  }
}
.preview .panel {
  flex: 1;
  padding: 15px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  h4 {
    font-size: small;
    font-weight: 600;
    margin-bottom: 10px;
  }
}
.form-group-panel {
  display: flex;
  margin-top: 10px;
  .label {
    width: 45%;
    font-size: x-small;
  }
  .value {
    width: 50%;
    font-size: x-small;
    text-align: end;
  }
  .divider {
    font-size: x-small;
    width: 5%;
  }
}
.form-group-panel.item {
  border-bottom: 1px solid;
  .label {
    width: 45%;
    font-size: x-small;
  }
  .value {
    width: 45%;
    font-size: x-small;
    text-align: end;
  }
  .divider {
    font-size: x-small;
    width: 10%;
  }
}

.box-info .title {
  color: #288dc2;
  border-bottom: 1px solid #d5dbe2;
  padding-bottom: 7px;
  font-weight: bold;
}
.file {
  position: relative;
}
.color {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 5px;
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  transform: translateY(-58%);
}
.box-info .description {
  margin-top: 15px;
  font-size: small;
}
.label {
  font-size: x-small;
  margin-bottom: 10px;
}
.form-group {
  margin-top: 10px;
}
.form-group .form-input {
  border: 1px solid #e7eaed;
  background: transparent;
  display: block;
  padding: 8px 10px 10px 8px;
  border-radius: 5px;
}
@media screen and (max-width: 768px) {
  .box-info {
    flex-wrap: wrap;
    .box2 {
      margin-top: 20px;
    }
  }
}
</style>
